import { InjectionToken } from '@angular/core';
import { TranslationDictionaryMapping } from '../models/translation-dictionary/translation-dictionary-mapping.type';

export const TRANSLATION_DICTIONARY_MAPPING = new InjectionToken<
  TranslationDictionaryMapping | TranslationDictionaryMapping[]
>('Translation dictionary mapping token');
